export default "__VITE_ASSET__DN38jV2l__"